export default __webpack_public_path__ + "static/media/nave.d6751081.bin";